/*
 *
 * TABBERJS
 *
 * Jquery plugin for tabblable panes,
 * Don't forget to include the scss file for respective styles
 *
 *  Usage:
 *  Tabs = require('./modules/tabs.js');
 *  Tabs.init();
 *
 */

var Tabs = {

	activate: function(el){
		el.addClass('active');
	},

	show: function($tab){

        var href = $tab.attr('href'),
        	target = $(href);

        if (target.length) {

            Tabs.resetAll($tab);
            Tabs.activate($tab);
            Tabs.activate(target);

        } else {
            throw new Error('The element does not have a valid target');
        }
	},

	resetAll: function($tab) {

        var parent = $tab.closest('.js-tabs');
        parent.find('.tabs__item, [data-toggle=tabs]').removeClass('active');
    },

	bindUIEvents: function(){
		$(document).on('click', '[data-toggle=tabs]', function(e) {
	        e.preventDefault();


			Tabs.show($(this));

	    });
	},

	init: function(el){
		Tabs.bindUIEvents();
	},
};

module.exports = Tabs;



// WEBPACK FOOTER //
// ./assets/src/js/modules/tabs.js